// This file is generated automatically by `scripts/build/fp.js`. Please, don't change it.
import fn from '../../isSameWeek/index.js';
import convertToFP from '../_lib/convertToFP/index.js';
var isSameWeekWithOptions = convertToFP(fn, 3);
export default isSameWeekWithOptions;


//////////////////
// WEBPACK FOOTER
// ./~/date-fns/esm/fp/isSameWeekWithOptions/index.js
// module id = 938
// module chunks = 0